import { useRef, useState } from 'react'
import { Dialog } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee, faEnvelope, faMailBulk, faMailForward, faMailReply, faPhone, faSpellCheck } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import FrequencyVisualizer from './FrequencyVisualizer';
import Stefan from './Stefan';
import Enrico from './Enrico';
import CoachingDetailComp from './CoachingDetailComp';
import CoachingDetailComp2 from './CoachingDetailComp2';
import Locations from './Locations';
import Contact from './Contact';
import Footer from './Footer';
import Comment from './Comment';
import React, { Fragment, Suspense, useEffect } from 'react';
import Coachingoffer from './Coaching';
import Gespraechsraum from './Gespraechsraum';

const navigation = [
  { name: 'Über uns', id: 'stefan' },
  { name: 'Angebot', id: 'coachingoffer' },
 { name: 'Gesprächsraum', path: '/gespraechsraum' },
  { name: 'Kontakt', id: 'contact' },
]
function useDynamicRefs() {
  const refsMap = useRef({});
  const getRef = (id) => {
    if (!refsMap.current[id]) {
      refsMap.current[id] = React.createRef();
    }
    return refsMap.current[id];
  };
  return getRef;
}

export default function Landing() {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const getRef = useDynamicRefs();
  // Refs für jeden Autor-Abschnitt
  const navigateToSection = (id) => {
   const ref = getRef(id);
   if (ref.current) {
     ref.current.scrollIntoView({ behavior: 'smooth' });
   }
   
 };
 

  return (
    <>
    <div className="bg-white bg-cover bg-no-repeat bg-center" style={{ backgroundImage: "url('Flussschleife im Sonnenuntergang2.jpeg')", height: '900px'}}>
      <header className="absolute inset-x-0 top-0 z-50">
        <nav className="flex items-center justify-between p-3 lg:px-8" aria-label="Global">
          <div className="flex lg:flex-1">
            <a href="#" className="-m-1 p-1">
              <span className="sr-only">Your Company</span>
              <img
                className="h-20 w-auto"
                src="Logo-Frequenz741-dunkel.svg"
                alt=""
                
              />
            </a>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-300"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-12">
            {navigation.map((item) => (
              <a key={item.name} onClick={() => item.path ? navigate(item.path) : navigateToSection(item.id)} className="cursor-pointer text-sm font-semibold leading-6 text-white" style={{ textShadow: "1px 1px 5px rgba(0, 0, 0, 1)" }}>
                {item.name}
              </a>
            ))}
          </div>
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <a onClick={() => window.location.href='mailto:info@frequenz741.de'} className="px-2 text-sm font-semibold leading-6 text-gray-100" title='E-Mail an info@frequenz741.de schreiben'>
            <FontAwesomeIcon icon={faEnvelope} />
            </a>
            <a onClick={() => window.location.href='tel:+491723570148'} className="px-2 text-sm font-semibold leading-6 text-gray-100" title='Telefonnummer +49 172 3570148 anrufen'>
            <FontAwesomeIcon icon={faPhone} />
            </a>
          </div>
        </nav>
        <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
          <div className="fixed inset-0 z-50" />
          <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 max-w-sm sm:ring-1 ring-gray-900/10">
            <div className="flex items-center justify-between">
              <a onClick={(e)=>{navigate('/')}} className="-m-1.5 p-1.5">
                <span className="sr-only">Frequenz 741</span>
                <img
                  className="h-20 w-auto"
                  src="Logo-Frequenz741-hell.svg"
                  alt=""
                />
              </a>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {navigation.map((item) => (
                    <a
                      key={item.name}
                      onClick={() => {
  if (item.path) {
    navigate(item.path);
  } else {
    navigateToSection(item.id);
  }
  setMobileMenuOpen(false);
}}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                    >
                      {item.name}
                    </a>
                  ))}
                </div>
                <div className="py-6">
                <a onClick={() => window.location.href='mailto:info@frequenz741.de'} className="px-2 text-sm font-semibold leading-6 text-gray-800" title='E-Mail an info@frequenz741.de schreiben'>
            <FontAwesomeIcon icon={faEnvelope} />
            </a>
            <a onClick={() => window.location.href='tel:+491723570148'} className="px-2 text-sm font-semibold leading-6 text-gray-800" title='Telefonnummer +49 172 3570148 anrufen'>
            <FontAwesomeIcon icon={faPhone} />
            </a>
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </header>

  {/* --- HERO SECTION MIT VOLLBILD-SPLIT & KLICKBEREICH UNTEN --- */}
<div className="relative w-full h-[900px] flex flex-row overflow-hidden" style={{ backgroundImage: "url('Flussschleife im Sonnenuntergang2.jpeg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>

  {/* 1. Das einheitliche Dach (Zentriert, volle Breite, NICHT klickbar) */}
  <div className="absolute top-0 left-0 w-full z-30 pt-32 px-4 flex flex-col items-center text-center pointer-events-none">
 <h1 className="text-4xl font-bold tracking-tight text-white sm:text-6xl" style={{ textShadow: "1px 1px 5px rgba(0, 0, 0, 1), 2px 2px 10px rgba(0, 0, 0, 1), 3px 3px 15px rgba(0, 0, 0, 1),2px 2px 10px rgba(0, 0, 0, 1)" }}>
            Ihre Frequenz. Ihr
            </h1>
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-6xl" style={{ textShadow: "1px 1px 5px rgba(0, 0, 0, 1), 2px 2px 10px rgba(0, 0, 0, 1), 3px 3px 15px rgba(0, 0, 0, 1),2px 2px 10px rgba(0, 0, 0, 1)" }}>
            Bewusstsein. Ihre
            </h1>
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-6xl" style={{ textShadow: "1px 1px 5px rgba(0, 0, 0, 1), 2px 2px 10px rgba(0, 0, 0, 1), 3px 3px 15px rgba(0, 0, 0, 1),2px 2px 10px rgba(0, 0, 0, 1)" }}>
            Veränderung.
            </h1>
          <br></br>
           <br></br>
           
            <p className="text-base sm:text-xl text-gray-200 max-w-4xl mx-auto drop-shadow-md" style={{ textShadow: "1px 1px 5px rgba(0, 0, 0, 1), 2px 2px 10px rgba(0, 0, 0, 1), 3px 3px 15px rgba(0, 0, 0, 1),2px 2px 10px rgba(0, 0, 0, 1)" }}>
      Ob dynamisches Wachstum im Team, klare Ausrichtung in der Führung oder ein geschützter Raum für neue Perspektiven – wir begleiten Ihre Veränderung.
    </p>
          
  </div>

  {/* 2. LINKE SEITE: Business & Coaching (Rot/Warm) */}
  <div className="relative w-1/2 h-full group">
    {/* Rotes Overlay - geht über die VOLLE Höhe (nicht klickbar) */}
    <div className="absolute inset-0 bg-gradient-to-r from-red-900/90 via-red-800/60 to-transparent opacity-80 pointer-events-none"></div>

    {/* Klickbarer Auswahlbereich - NUR in der UNTEREN HÄLFTE */}
    <div 
      onClick={() => navigateToSection('coachingoffer')}
      className="absolute bottom-0 left-0 w-full h-[60%] flex flex-col justify-center items-center text-center p-2 pb-12 sm:pb-24 cursor-pointer z-20"
    >
      <div className="transform transition-all duration-500 group-hover:scale-105 group-hover:-translate-y-2">
       
        <h2 className="text-lg sm:text-4xl font-bold text-white mb-2 sm:mb-4 drop-shadow-lg">
          Führung & Team
        </h2>
        {/* Zusatztext auf Mobile ausgeblendet */}
        <p className="  text-sm sm:text-lg text-red-50 mb-6 max-w-sm mx-auto opacity-90 drop-shadow-md">
          Potenziale entfesseln und die Arbeitsumgebung harmonisieren.
        </p>
        <span className="inline-flex items-center justify-center bg-white/10 border border-white text-white text-xs sm:text-base font-semibold py-2 px-3 sm:py-3 sm:px-6 rounded-full group-hover:bg-white group-hover:text-red-900 transition-all duration-300">
          Entdecken →
        </span>
      </div>
    </div>
  </div>

  {/* 3. RECHTE SEITE: Gesprächsraum (Grün/Natur) */}
  <div className="relative w-1/2 h-full group">
    {/* Grünes Overlay - geht über die VOLLE Höhe (nicht klickbar) */}
    <div className="absolute inset-0 bg-gradient-to-l from-emerald-900/90 via-emerald-800/60 to-transparent opacity-80 pointer-events-none"></div>

    {/* Klickbarer Auswahlbereich - NUR in der UNTEREN HÄLFTE */}
    <div 
      onClick={() => navigate('/gespraechsraum')}
      className="absolute bottom-0 left-0 w-full h-[60%] flex flex-col justify-center items-center text-center p-2 pb-12 sm:pb-24 cursor-pointer z-20"
    >
      <div className="transform transition-all duration-500 group-hover:scale-105 group-hover:-translate-y-2">
      
        <h2 className="text-lg sm:text-4xl font-bold text-white mb-2 sm:mb-4 drop-shadow-lg">
          Gesprächsraum
        </h2>
        {/* Zusatztext auf Mobile ausgeblendet */}
        <p className="  text-sm sm:text-lg text-emerald-50 mb-6 max-w-sm mx-auto opacity-90 drop-shadow-md">
          Ein geschützter, wertfreier Raum für Reflexion.
        </p>
        <span className="inline-flex items-center justify-center bg-white/10 border border-white text-white text-xs sm:text-base font-semibold py-2 px-3 sm:py-3 sm:px-6 rounded-full group-hover:bg-white group-hover:text-emerald-900 transition-all duration-300">
          Eintreten →
        </span>
      </div>
    </div>
  </div>

  
</div>
      
    
    </div>
    <FrequencyVisualizer/>
 
              <Comment/>
              <div ref={getRef('coachingoffer')}></div>
              <Coachingoffer/>
              <div ref={getRef('coach')}></div>
              <CoachingDetailComp2/>
              <CoachingDetailComp/>
              <div className="moveTop max-w-7xl mx-auto px-6 lg:px-8 py-20">
              <div className="bg-emerald-900 rounded-3xl p-8 md:p-14 shadow-2xl flex flex-col lg:flex-row items-center justify-between gap-10 relative overflow-hidden">
                {/* Dezenter Hintergrundeffekt */}
                <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent"></div>
                
                <div className="relative z-10 lg:w-2/3 text-center lg:text-left">
                  <span className="text-emerald-300 font-semibold tracking-wider uppercase text-sm mb-3 block">
                    Neues Angebot
                  </span>
                  <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                    Der Frequenz 741 Gesprächsraum
                  </h3>
                  <p className="text-emerald-50 text-lg md:text-xl leading-relaxed max-w-2xl">
                    Ein geschützter, wertfreier Ort für ehrliche Gespräche, neue Perspektiven und tiefe Klarheit im Miteinander. Auf Augenhöhe und vertraulich.
                  </p>
                </div>
                
                <div className="relative z-10 lg:w-1/3 flex justify-center lg:justify-end w-full">
                  <button 
                    onClick={() => navigate('/gespraechsraum')} 
                    className="group w-full sm:w-auto inline-flex items-center justify-center bg-white text-emerald-900 font-bold py-4 px-8 rounded-xl hover:bg-emerald-50 transition-all duration-300 shadow-lg text-lg"
                  >
                    Mehr erfahren 
                    <span className="ml-3 transform group-hover:translate-x-1 transition-transform duration-200">→</span>
                  </button>
                </div>
              </div>
            </div>
              <div ref={getRef('stefan')}></div>
              <Stefan />
              <Enrico/>
              <Locations/>
              <div ref={getRef('contact')}></div>
              <Contact />
              <Footer/>
    </>
  )
}
